/* ============================================================
   Olivia & Mary product page
   Behaviour ported from the approved HTML preview, rewired to
   live Shopify product data. Prices, variants, inventory and
   add-to-cart come from the store; every label and interaction
   parameter comes from section settings.
   ============================================================ */
(function () {
  'use strict';

  // Every Olivia section links this file, so the tag can appear several times
  // on one page. Run once; a second execution would double every listener.
  if (window.__oliviaPdpLoaded) return;
  window.__oliviaPdpLoaded = true;

  var ROOT_SELECTOR = '[data-olivia-pdp]';

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('[olivia-pdp] could not read data', error);
      return null;
    }
  }

  function fill(template, values) {
    // Square brackets, not Liquid braces: Shopify reads {{ x }} inside a JSON
    // template setting as a dynamic source and refuses the file.
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ----------------------------------------------------------
     Product controller: one per rendered product page.
     ---------------------------------------------------------- */
  function ProductController(root) {
    this.root = root;
    this.data = readJSON($('[data-olivia-product-data]', root));
    if (!this.data || !this.data.variants || !this.data.variants.length) return;

    this.settings = this.data.settings || {};
    this.selected = this.data.variants.filter(function (variant) {
      return variant.id === this.data.current_variant_id;
    }, this)[0] || this.data.variants[0];

    this.options = (this.selected.options || []).slice();
    this.required = (this.data.required_positions || []).map(Number);
    this.storageKey = 'olivia:choice:' + (this.data.product_id || '');
    this.galleries = [];

    // A size must be a conscious choice. Keep it only when the visitor arrived
    // on an explicit ?variant= link or already picked it earlier this session.
    if (!this.data.has_url_variant) {
      var remembered = this.restoreChoice();
      var self = this;
      this.required.forEach(function (position) {
        self.options[position - 1] = remembered ? remembered[position - 1] : null;
      });
      if (remembered) {
        this.options = this.options.map(function (value, index) {
          return remembered[index] !== undefined && remembered[index] !== null ? remembered[index] : value;
        });
      }
    }

    this.bind();
    this.update({ initial: true });
  }

  ProductController.prototype.restoreChoice = function () {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(this.storageKey) || 'null');
      if (!Array.isArray(saved) || saved.length !== this.options.length) return null;
      var variants = this.data.variants;
      // Every remembered value must still exist on this product.
      var valid = saved.every(function (value, index) {
        return value === null || variants.some(function (variant) { return variant.options[index] === value; });
      });
      return valid ? saved : null;
    } catch (error) {
      return null;
    }
  };

  ProductController.prototype.rememberChoice = function () {
    try {
      window.sessionStorage.setItem(this.storageKey, JSON.stringify(this.options));
    } catch (error) {
      /* Private browsing: the choice is simply not remembered. */
    }
  };

  ProductController.prototype.missingPosition = function () {
    for (var i = 0; i < this.options.length; i++) {
      if (this.options[i] === null || this.options[i] === undefined) return i + 1;
    }
    return 0;
  };

  /* Blocks every add-to-cart until each option is chosen. Runs in the capture
     phase, so the theme's own product-form never receives an incomplete submit. */
  ProductController.prototype.guardSubmit = function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-ol-form]')) return;
    var missing = this.missingPosition();
    if (!missing) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var name = String((this.data.option_names || [])[missing - 1] || '').toLowerCase();
    var message = fill(this.settings.select_error || 'Please choose your [option] first.', { option: name });
    var errors = $$('[data-ol-select-error]');
    errors.forEach(function (el) {
      el.textContent = message;
      el.hidden = false;
    });

    // Bring the picker that belongs to this button into view; the sticky bar
    // has no picker of its own, so it uses the first one on the page.
    var own = form.closest('.buybox, .final-grid');
    var ownError = own ? $('[data-ol-select-error]', own) : null;
    var target = (ownError || errors[0] || {}).parentNode || null;
    var firstButton = target ? $('[data-ol-option="' + missing + '"]:not([disabled])', target) : null;
    if (target) {
      target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
    }
    if (firstButton) firstButton.focus({ preventScroll: true });
  };

  ProductController.prototype.scope = function () {
    // Price, stock and buy elements live in several sections, so bind page-wide.
    return document;
  };

  ProductController.prototype.bind = function () {
    var self = this;

    this.scope().addEventListener('click', function (event) {
      var optionButton = event.target.closest('[data-ol-option]');
      if (optionButton && !optionButton.disabled) {
        event.preventDefault();
        self.selectOption(Number(optionButton.dataset.olOption), optionButton.dataset.olValue);
      }
    });

    document.addEventListener('submit', function (event) {
      self.guardSubmit(event);
    }, true);

    // Returning through the back button restores the page from memory; make
    // sure every picker, price and button still shows the same selection.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) self.update({ initial: true });
    });

    $$('[data-ol-gallery]').forEach(function (galleryEl) {
      self.galleries.push(new Gallery(galleryEl, self));
    });
  };

  ProductController.prototype.variantFor = function (options) {
    return this.data.variants.filter(function (variant) {
      return options.every(function (value, index) {
        return value === null || variant.options[index] === value;
      });
    })[0];
  };

  /* A value is offered when at least one variant carrying it is purchasable. */
  ProductController.prototype.valueAvailable = function (position, value) {
    var options = this.options.slice();
    options[position - 1] = value;
    return this.data.variants.some(function (variant) {
      if (!variant.available) return false;
      return options.every(function (wanted, index) {
        // Only honour the option being tested plus the options before it.
        if (index + 1 > position) return true;
        return wanted === null || variant.options[index] === wanted;
      });
    });
  };

  ProductController.prototype.selectOption = function (position, value) {
    // Never swap another option the shopper already chose; an impossible
    // combination simply cannot be bought until they change it.
    this.options[position - 1] = value;
    var match = this.variantFor(this.options);
    if (match) this.selected = match;
    this.rememberChoice();
    $$('[data-ol-select-error]').forEach(function (el) {
      el.hidden = true;
    });
    this.update({});
  };

  /* The exact variant for a complete choice, or null when that combination
     does not exist. With a choice still open it returns a close match, used
     only to show a price and a photo. */
  ProductController.prototype.currentVariant = function () {
    var match = this.variantFor(this.options);
    if (this.missingPosition()) return match || this.selected;
    return match || null;
  };

  ProductController.prototype.stockMessage = function (variant) {
    var s = this.settings;
    var incomplete = this.options.some(function (value) {
      return value === null || value === undefined;
    });

    if (incomplete) return s.stock_unselected || '';
    if (!variant) return fill(s.stock_soldout, { variant: this.options.join(' / ') });
    if (!variant.available) {
      return fill(s.stock_soldout, { variant: variant.title });
    }
    if (variant.inventory_managed === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= Number(s.stock_threshold || 0)) {
      return fill(s.stock_low, {
        count: variant.inventory_quantity,
        variant: variant.title
      });
    }
    return fill(s.stock_available || '', { variant: variant.title });
  };

  ProductController.prototype.update = function (context) {
    var exact = this.currentVariant();
    var selectionComplete = !this.missingPosition();
    var purchasable = !!(exact && exact.available && selectionComplete);
    // A combination that does not exist still shows the last valid price and photo.
    var variant = exact || this.selected;

    this.selected = variant;

    // --- option buttons -------------------------------------------------
    var self = this;
    $$('[data-ol-option]').forEach(function (button) {
      var position = Number(button.dataset.olOption);
      var value = button.dataset.olValue;
      var chosen = self.options[position - 1] === value;
      var offered = self.valueAvailable(position, value);

      button.setAttribute('aria-pressed', String(chosen));
      button.classList.toggle('is-unavailable', !offered);
      if (button.classList.contains('size-button') || button.classList.contains('swatch')) {
        button.disabled = !offered;
        if (!offered) {
          button.setAttribute('aria-label', button.dataset.olLabel + ' — ' + (self.settings.label_soldout || 'sold out'));
        } else {
          button.setAttribute('aria-label', button.dataset.olLabel);
        }
      }
    });

    $$('[data-ol-option-selected]').forEach(function (el) {
      var position = Number(el.dataset.olOptionSelected);
      el.textContent = self.options[position - 1] || '';
    });

    // --- price ----------------------------------------------------------
    var onSale = variant && variant.compare_at_price_raw > variant.price_raw;
    $$('[data-ol-price]').forEach(function (el) {
      el.textContent = variant ? variant.price : '';
    });
    $$('[data-ol-compare]').forEach(function (el) {
      el.textContent = variant ? variant.compare_at_price : '';
      el.hidden = !onSale;
    });
    $$('[data-ol-discount]').forEach(function (el) {
      el.hidden = !onSale;
      if (onSale) {
        var percent = Math.round((1 - variant.price_raw / variant.compare_at_price_raw) * 100);
        el.textContent = fill(self.settings.discount_label || '[percent]% OFF', { percent: percent });
      }
    });
    $$('[data-ol-savings]').forEach(function (el) {
      el.hidden = !onSale;
      if (onSale) el.textContent = fill(self.settings.savings_label || '', { amount: variant.savings });
    });
    // On sale the caption reads as the savings line, exactly like the preview.
    $$('[data-ol-caption-default]').forEach(function (el) {
      var savings = el.parentNode.querySelector('[data-ol-savings]');
      el.hidden = !!(onSale && savings);
    });

    // --- stock ----------------------------------------------------------
    var stock = this.stockMessage(exact);
    $$('[data-ol-stock]').forEach(function (el) {
      el.textContent = stock;
      el.hidden = !stock;
    });

    // --- buy buttons ----------------------------------------------------
    $$('form[data-ol-form] input[name="id"]').forEach(function (input) {
      if (variant) input.value = variant.id;
      input.disabled = !purchasable;
    });
    // An open choice keeps the button clickable, so a click can explain what
    // is missing. A sold-out or non-existent combination disables it.
    var blocked = selectionComplete && !purchasable;
    $$('[data-ol-atc]').forEach(function (button) {
      button.setAttribute('aria-disabled', String(blocked));
      button.disabled = blocked;
      var label = $('[data-ol-atc-label]', button);
      if (label) {
        label.textContent = selectionComplete
          ? (purchasable ? self.settings.atc_label : self.settings.atc_soldout_label)
          : self.settings.atc_incomplete_label || self.settings.atc_label;
      }
      var price = $('[data-ol-atc-price]', button);
      if (price) {
        price.textContent = purchasable && variant ? fill(self.settings.atc_price_label || '— [price]', { price: variant.price }) : '';
        price.hidden = !purchasable;
      }
    });

    $$('[data-ol-sticky-selection]').forEach(function (el) {
      var parts = [];
      if (variant && selectionComplete) parts.push(variant.title);
      if (stock) parts.push(stock);
      el.textContent = parts.join(' · ');
    });

    // --- gallery + address bar -----------------------------------------
    if (variant && variant.media_index !== null && variant.media_index !== undefined) {
      this.galleries.forEach(function (gallery) {
        gallery.show(variant.media_index, { silent: true });
      });
    }
    $$('[data-ol-variant-image]').forEach(function (img) {
      if (variant && variant.image_src) {
        img.src = variant.image_src;
        if (variant.image_alt) img.alt = variant.image_alt;
      }
    });

    // Only a complete, real choice goes into the address bar; otherwise a
    // reload would treat an unchosen size as an explicit variant link.
    if (!context.initial && exact && selectionComplete && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', exact.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (!context.initial) {
      document.dispatchEvent(new CustomEvent('olivia:variant:change', { detail: { variant: variant } }));
    }
  };

  /* ----------------------------------------------------------
     Gallery: arrows, thumbnails, counter, swipe.
     ---------------------------------------------------------- */
  function Gallery(el, controller) {
    this.el = el;
    this.controller = controller;
    this.slides = $$('[data-ol-slide]', el);
    this.thumbs = $$('[data-ol-thumb]', el);
    this.counter = $('[data-ol-counter]', el);
    this.index = 0;
    if (!this.slides.length) return;

    var self = this;

    var prev = $('[data-ol-prev]', el);
    var next = $('[data-ol-next]', el);
    if (prev) prev.addEventListener('click', function () { self.step(-1); });
    if (next) next.addEventListener('click', function () { self.step(1); });

    this.thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { self.show(i); });
    });

    var stage = $('[data-ol-stage]', el);
    if (stage) {
      var start = null;
      stage.addEventListener('touchstart', function (event) {
        start = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!start) return;
        var dx = event.changedTouches[0].clientX - start.x;
        var dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) self.step(dx < 0 ? 1 : -1);
        start = null;
      }, { passive: true });
    }

    el.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') self.step(-1);
      if (event.key === 'ArrowRight') self.step(1);
    });

    this.show(0, { silent: true });
  }

  Gallery.prototype.step = function (delta) {
    this.show(this.index + delta);
  };

  Gallery.prototype.show = function (index, options) {
    if (!this.slides.length) return;
    var count = this.slides.length;
    this.index = ((index % count) + count) % count;

    var active = this.index;
    this.slides.forEach(function (slide, i) {
      slide.hidden = i !== active;
    });
    this.thumbs.forEach(function (thumb, i) {
      thumb.setAttribute('aria-pressed', String(i === active));
    });
    if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + count;

    var stage = $('[data-ol-stage]', this.el);
    var slide = this.slides[this.index];
    if (stage && slide && slide.dataset.olAlt) stage.setAttribute('aria-label', slide.dataset.olAlt);

    if (!options || !options.silent) {
      var note = $('[data-ol-image-note]', this.el);
      if (note && slide && slide.dataset.olNote) note.textContent = slide.dataset.olNote;
    }
  };

  /* ----------------------------------------------------------
     Countdown: one deadline per tab, kept across refreshes.
     ---------------------------------------------------------- */
  function Countdown(el) {
    this.el = el;
    this.hours = $('[data-ol-hours]', el);
    this.minutes = $('[data-ol-minutes]', el);
    this.seconds = $('[data-ol-seconds]', el);
    this.mode = el.dataset.olCountdownMode || 'rolling';
    this.duration = Number(el.dataset.olCountdownSeconds || 0);
    this.endsAt = el.dataset.olCountdownEnd ? Date.parse(el.dataset.olCountdownEnd) : null;
    this.storageKey = 'olivia:countdown:' + (el.dataset.olCountdownKey || 'default');

    if (this.mode === 'fixed') {
      // No valid end date means no timer at all; never invent a deadline.
      if (!Number.isFinite(this.endsAt)) {
        var holder = el.closest('.offer-line__timer, .countdown-row');
        if (holder) holder.hidden = true;
        return;
      }
      this.deadline = this.endsAt;
    } else {
      this.deadline = this.restore();
    }

    this.tick();
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  Countdown.prototype.restore = function () {
    var deadline = Date.now() + this.duration * 1000;
    try {
      var saved = Number(window.sessionStorage.getItem(this.storageKey));
      if (Number.isFinite(saved) && saved > Date.now()) return saved;
      window.sessionStorage.setItem(this.storageKey, String(deadline));
    } catch (error) {
      /* Private browsing: the timer simply restarts. */
    }
    return deadline;
  };

  Countdown.prototype.tick = function () {
    var remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));

    if (this.hours) this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
    if (this.minutes) this.minutes.textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
    if (this.seconds) this.seconds.textContent = String(remaining % 60).padStart(2, '0');

    var ended = remaining <= 0;
    this.el.classList.toggle('is-ended', ended);
    var host = this.el.closest('[data-ol-offer]');
    if (host) {
      host.classList.toggle('is-ended', ended);
      $$('[data-ol-when-live]', host).forEach(function (node) { node.hidden = ended; });
      $$('[data-ol-when-ended]', host).forEach(function (node) { node.hidden = !ended; });
    }
    if (ended && this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  Countdown.prototype.destroy = function () {
    if (this.timer) clearInterval(this.timer);
  };

  /* ----------------------------------------------------------
     Reviews: rating filter and progressive disclosure.
     ---------------------------------------------------------- */
  function Reviews(el) {
    this.el = el;
    this.cards = $$('[data-ol-review]', el);
    this.step = Number(el.dataset.olReviewStep || 3);
    this.limit = this.step;
    this.filter = 'all';

    var self = this;
    var select = $('[data-ol-review-filter]', el);
    if (select) {
      select.addEventListener('change', function (event) {
        self.filter = event.target.value;
        self.limit = self.step;
        self.render();
      });
    }

    this.more = $('[data-ol-review-more]', el);
    if (this.more) {
      this.more.addEventListener('click', function () {
        self.limit += self.step;
        self.render();
      });
    }

    this.empty = $('[data-ol-review-empty]', el);
    this.render();
  }

  Reviews.prototype.matching = function () {
    var filter = this.filter;
    return this.cards.filter(function (card) {
      return filter === 'all' || card.dataset.olRating === filter;
    });
  };

  Reviews.prototype.render = function () {
    var matching = this.matching();
    var limit = this.limit;

    this.cards.forEach(function (card) {
      card.hidden = true;
    });
    matching.slice(0, limit).forEach(function (card) {
      card.hidden = false;
    });

    if (this.more) this.more.hidden = matching.length <= limit;
    if (this.empty) this.empty.hidden = matching.length !== 0;
  };

  /* ----------------------------------------------------------
     Review strip: arrows scroll the row one card at a time.
     ---------------------------------------------------------- */
  function ReviewStrip(el) {
    this.el = el;
    this.track = $('[data-ol-strip-track]', el);
    this.prev = $('[data-ol-strip-prev]', el);
    this.next = $('[data-ol-strip-next]', el);
    if (!this.track) return;

    var self = this;
    this.sync = this.sync.bind(this);

    if (this.prev) this.prev.addEventListener('click', function () { self.scrollBy(-1); });
    if (this.next) this.next.addEventListener('click', function () { self.scrollBy(1); });

    this.track.addEventListener('scroll', this.sync, { passive: true });
    window.addEventListener('resize', this.sync);
    this.sync();
  }

  ReviewStrip.prototype.step = function () {
    var card = $('.review-strip__card', this.track);
    if (!card) return this.track.clientWidth;
    var styles = window.getComputedStyle(this.track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  };

  ReviewStrip.prototype.scrollBy = function (direction) {
    this.track.scrollBy({
      left: this.step() * direction,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  };

  ReviewStrip.prototype.sync = function () {
    var max = this.track.scrollWidth - this.track.clientWidth;
    var at = this.track.scrollLeft;
    if (this.prev) this.prev.disabled = at <= 1;
    if (this.next) this.next.disabled = at >= max - 1;
  };

  /* ----------------------------------------------------------
     Size guide: modal plus inch/centimetre conversion.
     ---------------------------------------------------------- */
  function SizeGuide(dialog) {
    this.dialog = dialog;
    this.baseUnit = dialog.dataset.olBaseUnit || 'in';
    this.unit = this.baseUnit;

    var self = this;

    $$('[data-ol-unit]', dialog).forEach(function (button) {
      button.addEventListener('click', function () {
        self.unit = button.dataset.olUnit;
        self.render();
      });
    });

    $$('[data-ol-close]', dialog).forEach(function (button) {
      button.addEventListener('click', function () { dialog.close(); });
    });

    dialog.addEventListener('close', function () {
      document.body.style.overflow = '';
    });

    // Clicking the backdrop closes the dialog.
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      var outside =
        event.clientX < box.left || event.clientX > box.right ||
        event.clientY < box.top || event.clientY > box.bottom;
      if (outside) dialog.close();
    });

    this.render();
  }

  SizeGuide.prototype.render = function () {
    var self = this;

    $$('[data-ol-unit]', this.dialog).forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.olUnit === self.unit));
    });

    $$('[data-ol-measure]', this.dialog).forEach(function (cell) {
      var base = Number(cell.dataset.olMeasure);
      if (!Number.isFinite(base)) return;
      var value = self.unit === self.baseUnit
        ? base
        : self.unit === 'cm' ? base * 2.54 : base / 2.54;
      cell.textContent = Number(value.toFixed(1)) + (self.unit === 'in' ? '″' : ' cm');
    });
  };

  /* ----------------------------------------------------------
     Sticky buy bar: shown once the main button has scrolled away.
     ---------------------------------------------------------- */
  function StickyBar(bar) {
    this.bar = bar;
    this.anchorSelector = bar.dataset.olStickyAfter || '[data-ol-primary-buy]';
    this.update = this.update.bind(this);

    window.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.update();
  }

  StickyBar.prototype.update = function () {
    var anchor = $(this.anchorSelector);
    if (!anchor) {
      this.bar.hidden = true;
      return;
    }
    var anchorBox = anchor.getBoundingClientRect();
    var visible = anchorBox.bottom < 0;

    // Hide again over any region that already repeats the buy button,
    // and over the footer bottom so payment icons and copyright stay visible.
    $$('[data-ol-sticky-stop], .footer__content-bottom').forEach(function (stop) {
      var box = stop.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) visible = false;
    });

    this.bar.hidden = !visible;
  };

  /* ----------------------------------------------------------
     Size guide openers and generic in-page scroll links.
     ---------------------------------------------------------- */
  function bindGlobalClicks() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-ol-open-size-guide]');
      if (opener) {
        var dialog = $('[data-ol-size-guide]');
        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
          event.preventDefault();
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      var jump = event.target.closest('[data-ol-scroll-to]');
      if (jump) {
        var target = document.querySelector(jump.dataset.olScrollTo);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      }
    });
  }

  /* ----------------------------------------------------------
     Boot + Shopify theme editor lifecycle.
     ---------------------------------------------------------- */
  var instances = { countdowns: [], reviews: [], guides: [], sticky: [], products: [], strips: [] };

  function initIn(scope) {
    $$(ROOT_SELECTOR, scope).forEach(function (root) {
      if (root.dataset.olReady === 'true') return;
      root.dataset.olReady = 'true';
      instances.products.push(new ProductController(root));
    });

    $$('[data-ol-countdown]', scope).forEach(function (el) {
      if (el.dataset.olReady === 'true') return;
      el.dataset.olReady = 'true';
      instances.countdowns.push(new Countdown(el));
    });

    $$('[data-ol-reviews]', scope).forEach(function (el) {
      if (el.dataset.olReady === 'true') return;
      el.dataset.olReady = 'true';
      instances.reviews.push(new Reviews(el));
    });

    $$('[data-ol-strip]', scope).forEach(function (el) {
      if (el.dataset.olReady === 'true') return;
      el.dataset.olReady = 'true';
      instances.strips.push(new ReviewStrip(el));
    });

    $$('[data-ol-size-guide]', scope).forEach(function (el) {
      if (el.dataset.olReady === 'true') return;
      el.dataset.olReady = 'true';
      instances.guides.push(new SizeGuide(el));
    });

    $$('[data-ol-sticky]', scope).forEach(function (el) {
      if (el.dataset.olReady === 'true') return;
      el.dataset.olReady = 'true';
      instances.sticky.push(new StickyBar(el));
    });
  }

  function syncSizeGuideOpeners() {
    var dialog = $('[data-ol-size-guide]');
    var usable = !!(dialog && dialog.dataset.olEmpty !== 'true');
    $$('[data-ol-open-size-guide]').forEach(function (opener) {
      opener.hidden = !usable;
    });
  }

  function boot() {
    bindGlobalClicks();
    initIn(document);
    syncSizeGuideOpeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The editor replaces section markup; rebuild whatever landed in it.
  document.addEventListener('shopify:section:load', function (event) {
    instances.countdowns = instances.countdowns.filter(function (countdown) {
      if (event.target.contains(countdown.el)) {
        countdown.destroy();
        return false;
      }
      return true;
    });
    initIn(event.target);
    syncSizeGuideOpeners();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    instances.countdowns = instances.countdowns.filter(function (countdown) {
      if (event.target.contains(countdown.el)) {
        countdown.destroy();
        return false;
      }
      return true;
    });
  });

  // Selecting a hidden block in the editor should reveal it.
  document.addEventListener('shopify:block:select', function (event) {
    var review = event.target.closest('[data-ol-review]');
    if (review) review.hidden = false;

    var slide = event.target.closest('[data-ol-slide]');
    if (slide) {
      var gallery = slide.closest('[data-ol-gallery]');
      var slides = $$('[data-ol-slide]', gallery);
      slides.forEach(function (node, index) {
        if (node === slide) {
          instances.products.forEach(function (product) {
            product.galleries.forEach(function (instance) {
              if (instance.el === gallery) instance.show(index);
            });
          });
        }
      });
    }

    var card = event.target.closest('.review-strip__card');
    if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

    var details = event.target.closest('details');
    if (details) details.open = true;
  });
})();
